import React from "react";

const Vendor = ({ row }) => {
  return <div>{row?.vendor?.name}</div>;
};

export default Vendor;
